export const DASHBOARD_QUICK_ORDER_CREATE_QUOTE_REQUEST = 'DASHBOARD_QUICK_ORDER_CREATE_QUOTE_REQUEST'
export const DASHBOARD_QUICK_ORDER_CREATE_QUOTE_SUCCESS = 'DASHBOARD_QUICK_ORDER_CREATE_QUOTE_SUCCESS'
export const DASHBOARD_QUICK_ORDER_CREATE_QUOTE_FAIL = 'DASHBOARD_QUICK_ORDER_CREATE_QUOTE_FAIL'
export const DASHBOARD_QUICK_ORDER_CREATE_QUOTE_RESET = 'DASHBOARD_QUICK_ORDER_CREATE_QUOTE_RESET'

export const DASHBOARD_QUICK_ORDER_GET_HEADER_REQUEST = 'DASHBOARD_QUICK_ORDER_GET_HEADER_REQUEST'
export const DASHBOARD_QUICK_ORDER_GET_HEADER_SUCCESS = 'DASHBOARD_QUICK_ORDER_GET_HEADER_SUCCESS'
export const DASHBOARD_QUICK_ORDER_GET_HEADER_FAIL = 'DASHBOARD_QUICK_ORDER_GET_HEADER_FAIL'
export const DASHBOARD_QUICK_ORDER_GET_HEADER_RESET = 'DASHBOARD_QUICK_ORDER_GET_HEADER_RESET'

export const DASHBOARD_QUICK_ORDER_UPDATE_HEADER_REQUEST = 'DASHBOARD_QUICK_ORDER_UPDATE_HEADER_REQUEST'
export const DASHBOARD_QUICK_ORDER_UPDATE_HEADER_SUCCESS = 'DASHBOARD_QUICK_ORDER_UPDATE_HEADER_SUCCESS'
export const DASHBOARD_QUICK_ORDER_UPDATE_HEADER_FAIL = 'DASHBOARD_QUICK_ORDER_UPDATE_HEADER_FAIL'

export const DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_REQUEST = 'DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_REQUEST'
export const DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_SUCCESS = 'DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_SUCCESS'
export const DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_FAIL = 'DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_FAIL'
export const DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_RESET = 'DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_RESET'

export const DASHBOARD_QUICK_ORDER_RECENT_ORDERS_REQUEST = 'DASHBOARD_QUICK_ORDER_RECENT_ORDERS_REQUEST'
export const DASHBOARD_QUICK_ORDER_RECENT_ORDERS_SUCCESS = 'DASHBOARD_QUICK_ORDER_RECENT_ORDERS_SUCCESS'
export const DASHBOARD_QUICK_ORDER_RECENT_ORDERS_FAIL = 'DASHBOARD_QUICK_ORDER_RECENT_ORDERS_FAIL'

export const DASHBOARD_QUICK_ORDER_CLONE_REQUEST = 'DASHBOARD_QUICK_ORDER_CLONE_REQUEST'
export const DASHBOARD_QUICK_ORDER_CLONE_SUCCESS = 'DASHBOARD_QUICK_ORDER_CLONE_SUCCESS'
export const DASHBOARD_QUICK_ORDER_CLONE_FAIL = 'DASHBOARD_QUICK_ORDER_CLONE_FAIL'
export const DASHBOARD_QUICK_ORDER_CLONE_RESET = 'DASHBOARD_QUICK_ORDER_CLONE_RESET'

export const DASHBOARD_QUICK_ORDER_FAV_QUOTES_REQUEST = 'DASHBOARD_QUICK_ORDER_FAV_QUOTES_REQUEST'
export const DASHBOARD_QUICK_ORDER_FAV_QUOTES_SUCCESS = 'DASHBOARD_QUICK_ORDER_FAV_QUOTES_SUCCESS'
export const DASHBOARD_QUICK_ORDER_FAV_QUOTES_FAIL = 'DASHBOARD_QUICK_ORDER_FAV_QUOTES_FAIL'
